export const SELECTED_CATEGORY = 'SELECTED_CATEGORY'
export function setSelectedCategory(category) {
  return (dispatch, getState) => {
    const state = getState()

    dispatch({ type: SELECTED_CATEGORY, value: category })
    dispatch({ type: FILTER, value: { ...state.items.filterCriteria } })
  }
}

export const FILTER = 'FILTER'
export function setFilter(filter) {
  return (dispatch, getState) => {
    const state = getState()    

    const filterCriteria = { ...state.items.filterCriteria, [state.items.selectedCategory]: filter }
        
    dispatch({ type: FILTER, value: filterCriteria })
  }
}
